import { ReactElement, useEffect, useRef, useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { NftPurchaseFail } from '../../__partials/NftPurchaseFail';
import { NftPurchasePending } from '../../__partials/NftPurchasePending';
import { NftPurchaseSuccess } from '../../__partials/NftPurchaseSuccess';
import { placeOrder } from 'appRedux/restApi';
import { isMobile } from 'utils';
import { IS_KIOSK_VENICE_MODE } from 'constants/app/configs';

type PaymentStatusStripeProps = {
  handleSetSuccessStep?: () => void;
};

export const PaymentStatusStripe = ({
  handleSetSuccessStep
}: PaymentStatusStripeProps) => {
  const redirectTimeout = useRef<NodeJS.Timeout>();
  const stripe = useStripe();
  const [message, setMessage] = useState<string | null>('');
  const [messageComponent, setMessageComponent] = useState<ReactElement | null>(
    null
  );

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      'payment_intent_client_secret'
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      const params = {
        payment_method: 'stripe',
        payment_intent_method: paymentIntent?.payment_method as string,
        payment_intent_id: paymentIntent?.id as string
      };

      switch (paymentIntent?.status) {
        case 'succeeded':
          setMessageComponent(NftPurchasePending);
          void placeOrder(undefined, params, (success, error) => {
            if (success) {
              if (IS_KIOSK_VENICE_MODE) {
                setMessageComponent(NftPurchaseSuccess);
                redirectTimeout.current = setTimeout(() => {
                  if (handleSetSuccessStep) {
                    handleSetSuccessStep();
                  }
                }, 5000);
              } else {
                if (isMobile()) {
                  setMessageComponent(NftPurchaseSuccess);
                } else {
                  if (handleSetSuccessStep) {
                    handleSetSuccessStep();
                  }
                }
              }
            }
            if (error) {
              setMessageComponent(NftPurchaseFail);
            }
          });

          break;
        case 'processing':
          setMessageComponent(NftPurchasePending);
          break;
        case 'requires_payment_method':
          setMessageComponent(NftPurchaseFail);
          break;
        default:
          setMessage('Something went wrong.');
          break;
      }
      localStorage.setItem('paymentPending', JSON.stringify(false));
    });
    return () => {
      clearTimeout(redirectTimeout.current);
    };
  }, [stripe]);

  return messageComponent || <span>{message}</span>;
};
